import React, { PureComponent, HTMLAttributes } from 'react';
import './TitledBorder.less';

export interface TitledBorderProps extends HTMLAttributes<HTMLElement> {
    title?: string;
}
export default class TitledBorder extends PureComponent<TitledBorderProps> {
    render() {
        const { title, children, ...otherProps } = this.props;
        return (
            <section className="titled-border" {...otherProps}>
                <div className="titled-border-title">{title}</div>
                <div className="titled-border-content">{children}</div>
            </section>
        );
    }
}
